export default "__VITE_ASSET__ofY5jC19FGqQloXnUK9kgQ__";